import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <FAQSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CarouselSection />
        <AboutSection />
        <ContactSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}